<div class="linear-progress-wrapper" *ngIf="isLinear">
    <linear-progress
        *ngIf="isMyTurn$ | async"
        [currentProgress]="myTurn$ | async"
        [color]="'#003260'"
        background="rgba(0, 0, 0, 0.15)">
    </linear-progress>
</div>
<div *ngIf="!isLinear">
    <circle-progress
    *ngIf="isMyTurn$ | async"
    [currentProgress]="myTurn$ | async"
    color="#feff00"
    background="rgba(0, 0, 0, 0.15)"
    [radius]="radiusValue">
</circle-progress>
</div>

